import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import { Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledDropdown } from 'reactstrap';
import FontAwesomeIcon from '../../helpers/fontawesome/fontAwesome';
import InfoText from '../UI/infoText/InfoText';
import { VE_PHONE_FORMAT } from '../../helpers/utils';

const ProviderListItem = ({
    mutate,
    avatar,
    title,
    description,
    alternativeName,
    toDeleteId,
    onDeleteAction,
    onDetailsAction,
    onSeeAction,
    onEditAction,
    options,
    createdAt,
    address,
    dni,
    email,
    phone,
    ...rest
}) => {

    const [collapseOne, collapseOneOpen] = useState(false)

    const handleDropdownAction = (action) => {
        if (action === 'edit') { onEditAction(rest); return; }
        if (action === 'delete') { return collapseOneOpen(true); }
        throw new Error('invalid action');
    }

    const handleDetails = () => {
        onDetailsAction(title, {
            name: title,
      
        });
      };
      

    const handleDelete = () => {
        collapseOneOpen(false);
        onDeleteAction(rest);
    }

    const handleModal = () =>
        <Modal isOpen={collapseOne} data-testid="modal">
            <ModalHeader>Eliminar {title}</ModalHeader>
            <ModalBody>
                <p className="mb-0 font-weight-bold fs--1">¿Está seguro de eliminar el {alternativeName} {title}?</p>
            </ModalBody>
            <ModalFooter>
                <Button onClick={() => collapseOneOpen(!collapseOne)}>
                    Cancelar
                </Button>
                <Button
                    data-testid="delete-button"
                    color="danger"
                    onClick={handleDelete}>Eliminar</Button>
            </ModalFooter>
        </Modal>

    return <>
        <tr >
            <td>{title}</td>
            <td>{description ? <InfoText max={20} text={description} /> : 'Proveedor'}</td>
            <td>{email || 'Correo no registrado'}</td>
            <td>{phone ? <NumberFormat type='tel' displayType='text' placeholder="Télefono" value={phone} format={VE_PHONE_FORMAT} /> : 'Teléfono no registrado'}</td>
            {options &&
                <td>
                    <Col xs="auto" className="d-sm-flex align-items-center">
                        <UncontrolledDropdown direction="left" className="d-inline-block ml-2">
                            <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu style={{ zIndex: 100 }}>
                                <DropdownItem onClick={handleDetails} title={title}>Ver detalles</DropdownItem>
                                <DropdownItem onClick={onEditAction}>Editar</DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem className="text-danger" onClick={() => handleDropdownAction('delete')}>Eliminar {alternativeName}</DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Col>
                </td>}
        </tr>
        {handleModal()}
    </>
}

export default ProviderListItem;